export default {
  zh: {
    sorryMessage: '请您把不喜欢的原因告诉我们吧，我们会持续改进。',
    cancelReasonList: [
      {
        id: 0,
        reason: '有技术问题影响正常使用',
        solution: '如果您遇到了技术问题，我们很乐意为您效劳，帮助您解决问题。我们为您准备了实用的小贴士以及常见问题解答。如果需要进一步的帮助，您也可以直接联系我们的客服邮箱'
      },
      {
        id: 1,
        reason: '价格太贵了',
        solution: '为了向您提供更加稳定安全的服务，我们还在不断地增加优化服务器的数量和质量。只因为我们希望可以提供更高级别的加密服务，保护用户的隐私和网络安全。'
      },
      {
        id: 2,
        reason: '我没有用加速器的需求',
        solution: '根据报道，已有31%的互联网用户会通过加速器上网。个人网络空间不断缩小，个人隐私不断面临威胁。我们希望可以通过Plex加速器帮助您在上网的时候远离安全隐患。'
      },
      {
        id: 3,
        reason: '我想要修改付款方式',
        solution: '想要更改套餐？升级账号或者是更改套餐很方便，您可以直接联系我们的客服iplexservice@gmail.com帮您解决。'
      },
      {
        id: 4,
        reason: '其他原因',
        solution: '互联网安全不断受到威胁，使用加速器保护个人上网数据变得越来越有必要。烦请告知我们您选择取消订阅的原因。请在下面空格内告知我们原因，我们会不断地进行改进。'
      }
    ],
    keepSubscription: '保留订阅',
    continueBtn: '继续',
    sure: '确定',
    proceedTitle: '您确认要继续该操作吗？',
    cancelSubscriptionNotice: '取消订阅代表当您用完您的剩余时间，您的Plex加速器账户就会过期。在这里由衷地建议您，保留订阅功能确认您的数据信息能时刻处于保护中。',
    cancelSubscription: '取消订阅',
    enterReason: '请输入不喜欢的原因',
    cancelSuccess: '您的订阅已取消，会员到期将不再继续自动扣费。'
  },
  en: {
    sorryMessage: 'We’re sorry to see you’re thinking of leaving us. Could you tell us why? We might be able to help.',
    cancelReasonList: [
      {
        id: 0,
        reason: 'Technical problem',
        solution: 'If you are experiencing a technical difficulty, we would be more than happy to help you solve the problem. We have prepared a number of helpful tips and frequent issue resolutions. If you would like a more in depth assistance, please contact us via '
      },
      {
        id: 1,
        reason: 'Trying to save money',
        solution: 'In order to provide advanced privacy solutions and stable connections, we are continuously expanding our server network and offering the most advanced security features. We hope to ensure top notch security solution is available to everyone who seeks privacy online.'
      },
      {
        id: 2,
        reason: 'Don’t need VPN',
        solution: '31% of internet users are accessing the internet though a VPN. As privacy online is under serious threat, we hope you stay secure online continuously.'
      },
      {
        id: 3,
        reason: 'I want to switch package of payment method',
        solution: 'We are glad to hear you are interested in taking advantage of yet another PlexVPN plan. Upgrading your account or changing your payment plan is currently the easiest by purchasing a new plan, or contacting us via iplexservice@gmail.com.'
      },
      {
        id: 4,
        reason: 'I have other reasons',
        solution: 'Securing your data with a VPN is essential as internet freedom is increasingly threatened. Could you tell us the reason for choosing to cancel your auto-renewal subscription. Please let us know below, we’ll do our utmost to improve our service.'
      }
    ],
    keepSubscription: 'Keep Subscription',
    continueBtn: 'Continue',
    sure: 'Sure',
    proceedTitle: 'Are you sure you want to proceed ?',
    cancelSubscriptionNotice: 'Cancelling the auto-renewal subscription would mean your PlexVPN account will expire at the end of the current payment period. It is recommended to keep auto-renewal subscription to ensure that your data is under protection at all times.',
    cancelSubscription: 'Cancel My Subscription',
    enterReason: 'Enter reason here...',
    cancelSuccess: 'Your subscription has been cancelled, it will not be auto-renewed.'
  }
}



// WEBPACK FOOTER //
// ./src/components/account/cancelSubscription/lang.js